// @flow
import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import CloseIcon from '@material-ui/icons/Close';
import type { User } from '../../../types';
import Field from '../../ui/Field';

const useStyles = makeStyles(theme => ({
    error: {
        backgroundColor: theme.palette.error.dark,
        margin: theme.spacing(2)
    }
}));

type Props = $ReadOnly<{
    user?: User,

    onClose: () => void,
    onSubmit: (user: User) => Promise<any>
}>;

function UserForm({ user, onClose, onSubmit }: Props) {
    const classes = useStyles();
    const [innerUser, setInnerUser] = useState(user);
    const [formError, setFormError] = useState();

    useEffect(() => {
        setInnerUser(user);
    }, [user]);

    const handleChange = (key) => (e) => {
        setInnerUser({
            ...innerUser,
            [key]: e.target.value
        });
        setFormError(null);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if(innerUser) {
            onSubmit(innerUser)
                .catch(setFormError);
        }

    };

    return (
        <form onSubmit={handleSubmit}>
            <IconButton onClick={onClose}>
                <CloseIcon/>
            </IconButton>

            <div>
                <Field
                    label={(
                        <FormattedMessage
                            id="userForm.name"
                            defaultMessage="Name"
                        />
                    )}
                    value={innerUser && innerUser.name}
                    onChange={handleChange('name')}
                />
                <Field
                    label={(
                        <FormattedMessage
                            id="userForm.email"
                            defaultMessage="Email"
                        />
                    )}
                    labelNote={(
                        <FormattedMessage
                            id="userForm.forLogin"
                            defaultMessage="For login"
                        />
                    )}
                    value={innerUser && innerUser.email}
                    disabled={Boolean(user)}
                    onChange={handleChange('email')}
                />
                <Field
                    type="password"
                    label={(
                        <FormattedMessage
                            id="userForm.password"
                            defaultMessage="Password"
                        />
                    )}
                    labelNote={(
                        <FormattedMessage
                            id="userForm.forLogin"
                            defaultMessage="For login"
                        />
                    )}
                    value={innerUser && innerUser.password}
                    onChange={handleChange('password')}
                />
                <Field
                    label={(
                        <FormattedMessage
                            id="userForm.phone"
                            defaultMessage="Phone"
                        />
                    )}
                    value={innerUser && innerUser.phone}
                    onChange={handleChange('phone')}
                >
                    +42X XXX XXX XXX
                    <a href="">
                        <FormattedMessage
                            id="userForm.sendTestSMS"
                            defaultMessage="Send test SMS"
                        />
                    </a>
                </Field>
            </div>

            {formError &&
                <SnackbarContent
                    className={classes.error}
                    message={(
                        <FormattedMessage
                            id="userForm.error"
                            defaultMessage="An error has occurred"
                        />
                    )}
                />
            }

            <Button
                type="submit"
                color="primary"
                variant="contained"
                fullWidth
            >
                <FormattedMessage
                    id="userForm.saveCTA"
                    defaultMessage="Save"
                />
            </Button>
        </form>
    );
}

export default UserForm;